import { LabelTemplateList, LabelTemplateSummary, } from '@aeris/contracts';
import { request } from "./client.js";
/**
 * `/api/v1/catalog/label-templates` — os modelos de etiqueta da loja (F124).
 *
 * O arquivo `.conf` do GDOOR sobe em base64 e é interpretado no SERVIDOR. Ler
 * aqui e mandar o layout pronto seria deixar a validação de um formato de outro
 * sistema no navegador — e este arquivo é Windows-1252, com vírgula decimal e
 * cor BGR do Delphi, exatamente onde dois leitores discordam sem avisar.
 */
export const fetchLabelTemplates = async (status, signal) => {
    const query = status === undefined ? '' : `?status=${status}`;
    const body = await request(`/api/v1/catalog/label-templates${query}`, {
        ...(signal ? { signal } : {}),
    });
    return LabelTemplateList.parse(body).templates;
};
/**
 * Os bytes do arquivo em base64, **sem passar por texto**.
 *
 * `FileReader.readAsText` decodificaria como UTF-8 e destruiria os acentos
 * antes de o servidor ver os bytes — "Preço" chegaria como um losango e sairia
 * assim, impresso, na etiqueta.
 */
export const fileToBase64 = async (file) => {
    const bytes = new Uint8Array(await file.arrayBuffer());
    let binary = '';
    // Em blocos: `String.fromCharCode(...bytes)` de uma vez estoura a pilha em
    // arquivo grande, e o limite depende do navegador — ou seja, funciona aqui e
    // falha no computador do cliente.
    const CHUNK = 0x8000;
    for (let index = 0; index < bytes.length; index += CHUNK) {
        binary += String.fromCharCode(...bytes.subarray(index, index + CHUNK));
    }
    return btoa(binary);
};
export const importLabelTemplate = async (input) => LabelTemplateSummary.parse(await request('/api/v1/catalog/label-templates/import', {
    method: 'POST',
    body: input,
}));
/** Um modelo feito no editor do Aeris (F129). O servidor valida o layout. */
export const createLabelTemplate = async (input) => LabelTemplateSummary.parse(await request('/api/v1/catalog/label-templates', {
    method: 'POST',
    body: input,
}));
export const updateLabelTemplate = async (id, input) => LabelTemplateSummary.parse(await request(`/api/v1/catalog/label-templates/${id}`, {
    method: 'PATCH',
    body: input,
}));
export const deleteLabelTemplate = async (id) => {
    await request(`/api/v1/catalog/label-templates/${id}`, { method: 'DELETE' });
};
//# sourceMappingURL=labels.js.map